


























import Vue from 'vue'
import { fetchLibratoUser, fetchLibratoToken } from '@/helpers/librato'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'

export default Vue.extend({
  name: 'LibratoChart',
  props: {
    width: {
      type: Number,
      required: false,
      default: 620
    },
    height: {
      type: Number,
      required: false,
      default: 300
    },
    chartId: {
      type: Number,
      required: true
    },
    query: {
      type: String,
      required: true
    },
    duration: {
      type: Number,
      required: true
    }
  },
  computed: {
    libratoUser (): string {
      const state = this.$store.direct.state
      const user = fetchLibratoUser(state)
      return user
    },
    libratoToken (): string {
      const state = this.$store.direct.state
      const token = fetchLibratoToken(state)
      return token
    }
  },
  components: {
    ClipLoader
  }
})

